export function gEvent(event, category, label) {
  window.gtag("event", event, {
    event_category: category,
    event_label: label,
    non_interaction: false,
  });
  return "Success";
}
